import React from 'react';
import ReactDOM from 'react-dom';
import { Switch, Route } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import Fastclick from 'react-fastclick';

import store, { history } from 'store';

import { initialize } from 'store/actions/combined.actions';
import AppWrapper from 'components/app-wrapper';
import Home from 'components/home';
import Configure from 'components/configure';
import Changelog from 'components/changelog';
import GameRoutes from 'components/game-routes';
import * as serviceWorker from './serviceWorker';

import 'styles/global.scss';
import 'react-hint/css/index.css';

Fastclick();
store.dispatch(initialize());

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Switch>
        <AppWrapper>
          <Route exact path="/" component={Home} />
          <Route path="/configure" component={Configure} />
          <Route path="/changelog" component={Changelog} />
          <Route
            path="/(sector|overview|elements)/:sector"
            component={GameRoutes}
          />
        </AppWrapper>
      </Switch>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root'),
);

serviceWorker.unregister();
